import { useCallback, useEffect, useState } from 'react';
import { navLinks } from '../constants';
import { styles } from '../styles';
import { Menu, Close, logo1w } from '../assets';
import { Link } from 'react-router-dom';
import IconBtn from './buttons/IconBtn';
import ThemeBtn from './buttons/ThemeBtn';
import { HashLink } from 'react-router-hash-link';

const MobileNav = ({ setToggle, changeTheme, theme }) => {
  return (
    <>
      <div className="sm:hidden flex">
        <div
          className={`flex fixed inset-0 top-[60px] sm:top-[76px] min-w-[160px] z-40 backdrop-blur-sm opacity-fade-in-up mobile-nav-dynamic`}
          onClick={() => setToggle(false)}
        >
          <div
            className="flex flex-col justify-between mx-4 my-4 w-full h-fit bg-secondary p-6 rounded-xl gap-2 min-w-[160px] z-50 fade-in-up"
            onClick={e => e.stopPropagation()}
          >
            <ul className="flex flex-col gap-4 min-w-[160px]">
              {navLinks.map(({ id, title }, idx) => (
                <li
                  key={idx}
                  onClick={() => {
                    setToggle(false);
                  }}
                >
                  <HashLink to={`#${id}`} className={`text-[16px] text-txt-primary`}>
                    <div className="w-full">{title}</div>
                  </HashLink>
                </li>
              ))}
            </ul>
            <div className="flex flex-row justify-end">
              <ThemeBtn theme={theme} changeTheme={changeTheme} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Navbar = () => {

  const INITIAL_THEME = localStorage.getItem('currentMode') || 'dark';

  const [toggle, setToggle] = useState(false);
  const [theme, setTheme] = useState(INITIAL_THEME);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // for Theme
    if (theme === 'dark') {
      document.body.classList.remove('light');
      document.body.classList.add('dark');
    }
    else {
      document.body.classList.remove('dark');
      document.body.classList.add('light');
    }

    localStorage.setItem('currentMode',`${theme}`)
  }, [theme]);

  const changeTheme = useCallback(() => {
    setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
  }, []);

  return (
    <nav>
      <div
        className={`${styles.paddingX} py-3 sm:py-3 ${
          // scrolled || toggle ? 'bg-primary' : 'bg-transparent'
          scrolled || toggle ? 'navbar-dynamic' : 'bg-transparent'
        } fixed z-30 top-0 w-full flex justify-center items-center text-base`}
        onClick={() => {
          setToggle(false);
        }}
      >
        <div
          className={`w-full flex flex-row justify-between items-center gap-7 max-w-7xl`}
        >
          <HashLink
            to="/"
            onClick={e => {
              e.stopPropagation();
              window.scrollTo(0, 0);
              setToggle(false);
            }}
            className="flex flex-row items-center gap-3"
          >
            <div className="shrink-0 w-full">
              <img 
                  loading='lazy' fetchPriority="high" src={logo1w} alt="" className="w-full max-h-6  img-logo" />
            </div>
          </HashLink>

          <ul className="gap-2 sm:gap-4 md:gap-6 lg:gap-10 hidden sm:flex font-medium items-center">
            {navLinks.map(({ id, title }, idx) => (
              <li key={idx}>
                <HashLink
                  to={`#${id}`}
                  className="text-txt-secondary hover:text-white-100"
                >
                  {title}
                </HashLink>
              </li>
            ))}
            <ThemeBtn theme={theme} changeTheme={changeTheme} />
          </ul>
          <div className="sm:hidden flex">
            <button
              onClick={e => {
                e.stopPropagation();
                setToggle(prev => !prev);
              }}
            >
              <IconBtn>{toggle ? <Close className="svg-dynamic-color" /> : <Menu className="svg-dynamic-color" />}</IconBtn>
            </button>
          </div>
        </div>
      </div>
      {toggle && (
        <MobileNav
          setToggle={setToggle}
          theme={theme}
          changeTheme={changeTheme}
        />
      )}
    </nav>
  );
};

export default Navbar;
